<template>
  <w-form class="xs12 fill-width mb5" :disabled="disabled" v-model="valid"
    ><w-flex>
      <w-input v-model="toAdd" :validators="required?[validators.required]:[(value)=>true]"></w-input
      ><w-button
        :disabled="disabled"
        @click.prevent="valid ? addToList() : null"
        >Add</w-button
      >
    </w-flex></w-form
  >
  <w-list :items="itemsList" class="title3 py3 xs12 fill-width">
    <template #item="{ item }">
      <div class="xs12">
        <w-flex class="align-center"
          ><w-icon hover color="red-dark3" class="button-icon  mr3 pxa mya" @click="removeFromList(item.value)"
            >mdi mdi-close</w-icon
          ><span class="text-bold">{{ item.label }} </span>
          <div class="spacer"></div>
        </w-flex>
        <w-divider class="xs12 fill-width"></w-divider>
      </div>
    </template>
  </w-list>

</template>
<script>

import { ref, reactive, computed, watch } from "vue";
export default {
  name: "interactiveList",
  props: {
    list: Array(),
    disabled: Boolean(),
    required:Boolean(),
  },
  emits: ["addToList", "removeFromList"],
  setup: (props, { emit }) => {
    const valid = reactive(null);
    let toAdd = ref("");
    //emit
    function addToList() {
      if(!!toAdd.value && toAdd.value != "" && toAdd.value.trim()!= ""){
      emit("addToList", toAdd.value);}
    }
    //emit
    function removeFromList(target) {
      emit("removeFromList", target);
    }

    function toAddL(label) {
      toAdd.value = label;
    }
    const itemsList = computed(() => {
      if (!props.list) return []; // ✅ Return an empty array if undefined
      console.log(props.list);
      return props.list;
    });
    watch(
      itemsList,
      (newValue, oldValue) => {
        console.log("new", newValue);
        return newValue ? newValue : oldValue;
      },
      { deep: true }
    );
    return {
      valid,
      validators: {
        required: (value) =>
          (!!value && value != "") || "This field is required",
      },
      toAdd,
      addToList,
      removeFromList,
      itemsList,
      toAddL,
    };
  },
  //watch props and update as they change
  //   watch: {
  //     items(newValue, oldValue) {
  //       if (newValue != oldValue )
  //       items
  //     }
  //   }
};
</script>
<style>
.button-icon{
 cursor: pointer;
}
</style>
